import { RobotoLink } from "@/shared/components";
import {
  AssociationType,
  fileAssociationType,
} from "@/shared/domain/association";
import { useDataset } from "@/shared/domain/datasets/hooks";
import { FileRecord } from "@/shared/domain/files";
import { dirname } from "@/shared/domain/files/filesystem";
import { Goto } from "@/shared/navigation";

interface FileParentAssociation {
  /** The current file record */
  fileRecord: FileRecord;
}

/**
 * The ID of the dataset, org, device or device type that holds the file, linked
 * to the page `Goto.createAssociationRoute` picks for the file's folder. A
 * dataset's label also shows the dataset's name.
 */
export function FileParentAssociation({ fileRecord }: FileParentAssociation) {
  const associationId = fileRecord.association_id;
  const isDataset =
    fileAssociationType(associationId) === AssociationType.Dataset;
  const datasetQuery = useDataset(isDataset ? associationId : undefined);
  const dataset = datasetQuery.data;

  return (
    <RobotoLink
      to={Goto.createAssociationRoute(
        associationId,
        dirname(fileRecord.relative_path),
      )}
    >
      {dataset?.name ? `${associationId} (${dataset.name})` : associationId}
    </RobotoLink>
  );
}
